import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import DisbursementOverview from '../v2/pages/Disbursement/DisbursementOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'

export const disbursementBaseUrl = '/disbursement/:action?'

export default function Disbursements(props: EntityPageProps): ReactElement {
    return (
        <EntityPage {...props} baseUrl={disbursementBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <Switch>
                    <Route
                        path={route}
                        render={(routeProps: RouteComponentProps) => (
                            <DisbursementOverview
                                {...routeProps}
                                fileId={props.currentFile?.id}
                                baseUrl={baseUrl}
                                localStorageKeyPrefix={`HammockDisbursementOverview-${props.currentFile?.id}-`}
                            />
                        )}
                    />
                </Switch>
            )}
        </EntityPage>
    )
}
